module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/bitmap-03c57f6cc39945b3f19d1192d2b495b4.svg";